/**
 * État partagé entre l’étape 2 de création/édition et la page parente
 * (sélection des IDs + paliers personnalisés par référence).
 */
import type { BoosterReferenceTierMap } from './booster-reference-tiers.ts';

export interface BoosterReferencesSelectionState {
  selectedReferenceIds: number[];
  customTiersByReferenceId: BoosterReferenceTierMap;
}

export const EMPTY_BOOSTER_REFERENCES_SELECTION: BoosterReferencesSelectionState = {
  selectedReferenceIds: [],
  customTiersByReferenceId: {}
};

/** Retire les IDs de références devenues indisponibles sur la période du booster. */
export function pruneSelectedReferenceIds(
  selectedReferenceIds: number[],
  selectableReferenceIds: ReadonlySet<number>
) {
  return selectedReferenceIds.filter((referenceId) => selectableReferenceIds.has(referenceId));
}

/** Helper Set pour la table et les compteurs de sélection. */
export function selectedReferenceIdsToSet(selectedReferenceIds: number[]) {
  return new Set(selectedReferenceIds);
}
